import React from 'react';
import { Link } from 'react-router-dom';



const BreadCrumbOne = ({title, page}) => {
    return (
        <div className="breadcrum-area">
            <div className="container">
                <div className="breadcrumb">
                    <ul className="list-unstyled">
                        <li>
                            <Link to={process.env.PUBLIC_URL + "/"}>Home</Link>
                        </li>
                        <li className="active" dangerouslySetInnerHTML={{__html: page}}></li>
                    </ul>
                    <h1 className="title h2" dangerouslySetInnerHTML={{__html: title}}></h1>
                </div>
                <div className="social-share" style={{ top: '20px', right: '20px'}}>
                <button 
                    style={{
                        background: '#4267B2',
                        border: 'none',
                        borderRadius: '20px',
                        color: 'white',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '16px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        transition: 'transform 0.2s ease',
                        hover: {
                            transform: 'scale(1.05)'
                        }
                    }}
                    onClick={() => {
                        const url = window.location.href;
                        if (navigator.share) {
                            navigator.share({
                                title: title,
                                text: 'Check out this post!',
                                url: url,
                            })
                            .catch((error) => console.log('Error sharing:', error));
                        } else {
                            window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`);
                        }
                    }} 
                    className="share-button"
                >
                    <span>🔗</span>
                    Compártelo
                </button>
            </div>
            </div>
            
            <ul className="shape-group-8 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"} alt="Bubble" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"} alt="Bubble" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
            </ul>
        </div>
    )
}

export default BreadCrumbOne;